import { api } from '../core/api';

/** section — раздел (содержит подразделы и статьи), article — статья */
export type MethodologyKind = 'section' | 'article';

/** Узел дерева без содержимого — для сайдбара. */
export interface MethodologyNode {
  id: string;
  parent_id: string | null;
  kind: MethodologyKind;
  title: string;
  sort_order: number;
  has_content: boolean;
}

export interface MethodologyPage {
  id: string;
  parent_id: string | null;
  kind: MethodologyKind;
  title: string;
  content: string;
  sort_order: number;
  CreatedOn: string;
  CreatedBy: string;
  ModifiedOn: string;
  ModifiedBy: string;
}

export const methodologyService = {
  getTree: () =>
    api.get<MethodologyNode[]>('/methodology/tree'),

  getPage: (id: string) =>
    api.get<MethodologyPage>(`/methodology/pages/${id}`),

  createPage: (data: { parent_id: string | null; kind: MethodologyKind; title: string; content?: string }) =>
    api.post<MethodologyPage>('/methodology/pages', data),

  updatePage: (id: string, data: { title?: string; content?: string }) =>
    api.put<MethodologyPage>(`/methodology/pages/${id}`, data),

  movePage: (id: string, data: { parent_id: string | null; index: number }) =>
    api.put<void>(`/methodology/pages/${id}/move`, data),

  deletePage: (id: string) =>
    api.delete<{ deleted: number }>(`/methodology/pages/${id}`),
};
